module.exports = __webpack_public_path__ + "static/media/distrame11.93f124da.webp";